import { FC } from 'react';
import { useSelectorWithConfig } from 'shared/hooks';
import { selectMortgagePromoSearchTypeFilter } from 'shared/selectors/advancedFilters/mortgagePromoSearchType';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter';
import { SingleMortgageSearchTypeContainer } from './SingleMortgageSearchTypeContainer';
import { MultipleMortgageSearchTypeContainer } from './MultipleMortgageSearchTypeContainer';
import { useMortgagePromoInfo } from 'shared/containers/AdvancedFiltersContainer/containers/AdvancedFiltersContentContainer/containers/MortgagePromoSearchTypeContainer/hooks/useMortgagePromoInfo';
import { SliderModal } from '@cian/frontend-newbuilding-promo-modal-widget';
import { AdvancedFilterRowLabelInfo } from 'shared/components/AdvancedFilter/components/AdvancedFilterRowLabelInfo';
import {
  trackNextInfoSlideShow,
  trackInfoArticleClick,
} from 'shared/containers/AdvancedFiltersContainer/containers/AdvancedFiltersContentContainer/containers/MortgagePromoSearchTypeContainer/tracking';

interface IMortgagePromoSearchTypeContainerProps {
  isNew?: boolean;
  title?: string;
  allowMultiple?: boolean;
}

export const MortgageSearchTypeContainer: FC<IMortgagePromoSearchTypeContainerProps> = ({
  isNew,
  title,
  allowMultiple = true,
}) => {
  const { isInfoModalVisible, infoSlides, openInfoModal, closeInfoModal } = useMortgagePromoInfo();

  const { label } = useSelectorWithConfig(selectMortgagePromoSearchTypeFilter);

  const info = !!infoSlides && (
    <AdvancedFilterRowLabelInfo testId="mortgagePromoSearchType|info" onClick={openInfoModal}>
      {isInfoModalVisible && (
        <SliderModal
          slides={infoSlides}
          onClose={closeInfoModal}
          onScrollNext={trackNextInfoSlideShow}
          onArticleClick={trackInfoArticleClick}
        />
      )}
    </AdvancedFilterRowLabelInfo>
  );

  return (
    <AdvancedFilterRow label={title || label} info={info} isNew={isNew}>
      {allowMultiple ? <MultipleMortgageSearchTypeContainer /> : <SingleMortgageSearchTypeContainer />}
    </AdvancedFilterRow>
  );
};
